import React from 'react';
import {
    Box,
    Text,
    Flex,
    IconButton,
} from "@chakra-ui/react";
import { DeleteIcon, CheckIcon } from "@chakra-ui/icons";
import { formatDuration } from '../../utils/helper';

export const VideoCard = ({ video, onDelete, isHideDelete = false, isSelection = false, selectMedia, mediaUrl }) => {
    const url = !Array.isArray(mediaUrl) ? [mediaUrl] : mediaUrl
    return (
        <Box
            key={video.id}
            bg="white"
            boxShadow="md"
            borderRadius="lg"
            overflow="hidden"
            position="relative"
            _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
            backgroundColor={url.includes(`https://player.vimeo.com/video/${video.id}`) ? "blue.200" : "white"}
            onClick={isSelection ? () => selectMedia("videos", `https://player.vimeo.com/video/${video.id}`, {...video, url: `https://player.vimeo.com/video/${video.id}`}) : null}
        >
            {/* Video Thumbnail */}
            <Box
                bg="gray.100"
                overflow="hidden"
                position="relative"
                paddingBottom="56.25%"
                display="flex"
                justifyContent="center"
                alignItems="center"
            >
                <Box
                    as="iframe"
                    sx={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                    src={`https://player.vimeo.com/video/${video.id}`}
                    title={video.name}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            </Box>

            {/* Video Details */}
            <Box p={2}>
                <Text fontWeight="bold" isTruncated>
                    {video.name}
                </Text>
                <Flex justify="space-between" mt={2} align="center">
                    <Text fontSize="sm" color="gray.500">
                        {formatDuration(video.duration)}
                    </Text>
                    {
                        !isHideDelete ?
                            <IconButton
                                aria-label="Delete"
                                icon={<DeleteIcon />}
                                size="sm"
                                variant="ghost"
                                colorScheme="red"
                                onClick={() => onDelete(video.id)}
                            /> : 
                            <>
                                {
                                    url.includes(`https://player.vimeo.com/video/${video.id}`) ?
                                        <CheckIcon color="blue.500" /> : <></>
                                }
                            </>
                    }
                    
                </Flex>
            </Box>
        </Box>
    );
}
